'use strict';

var react = require('@emotion/react');
var zIndex = require('../../../../constants/zIndex.cjs');

const coreActions = /*#__PURE__*/ react.css({
    padding: "8px 0",
    position: "relative",
    zIndex: zIndex.cardAction
}, "label:label-CoreActions-web-stylescoreActions", "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL1VzZXJzL2lhbmNsYXJrZS9kZXYvYXZpYXJ5L3BhY2thZ2VzL2F2aWFyeS13ZWIvc3JjL2NvbXBvbmVudHMvcGxhdGZvcm0vUHJvZHVjdENhcmQvQ29yZUFjdGlvbnMvQ29yZUFjdGlvbnMud2ViLnN0eWxlcy50cyIsInNvdXJjZXMiOlsiL1VzZXJzL2lhbmNsYXJrZS9kZXYvYXZpYXJ5L3BhY2thZ2VzL2F2aWFyeS13ZWIvc3JjL2NvbXBvbmVudHMvcGxhdGZvcm0vUHJvZHVjdENhcmQvQ29yZUFjdGlvbnMvQ29yZUFjdGlvbnMud2ViLnN0eWxlcy50cyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBjc3MgfSBmcm9tIFwiQGVtb3Rpb24vcmVhY3RcIjtcblxuaW1wb3J0IHsgekluZGV4IH0gZnJvbSBcIiNjb25zdGFudHNcIjtcblxuZXhwb3J0IGNvbnN0IGNvcmVBY3Rpb25zID0gY3NzKHtcbiAgcGFkZGluZzogXCI4cHggMFwiLFxuICBwb3NpdGlvbjogXCJyZWxhdGl2ZVwiLFxuICB6SW5kZXg6IHpJbmRleC5jYXJkQWN0aW9uLFxufSk7XG4iXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBSTJCIn0= */");

exports.coreActions = coreActions;
//# sourceMappingURL=CoreActions.web.styles.cjs.map
